export enum IFCurrencies {
  EUR = '€',
  USD = '$',
  GBP = '$'
}
